/* ============================================================
   Sign Creator — section-sign-creator.js

   Gallery note: signs are stored in localStorage, so the gallery
   is per-browser. For a shared cross-user gallery a backend API
   or Shopify metaobjects would be needed.
   ============================================================ */

(function () {
  'use strict';

  var NUM_ROWS = 7;
  var LOCKED_ROWS = 2; // rows 0 and 1 are the Chez Greenberg header — not editable
  var MAX_CHARS = 15; // per row

  /* ─── State ─────────────────────────────────────────────── */
  var selectedRow = LOCKED_ROWS; // start on first editable row
  var currentColor = 'black';
  var rows = initRows();

  function initRows() {
    var r = [];
    for (var i = 0; i < NUM_ROWS; i++) r.push([]);
    // Locked header rows — red, not editable
    r[0] = '\u2665 CHEZ \u2665'.split('').map(function (c) { return { char: c, color: 'red' }; });
    r[1] = 'GREENBERG'.split('').map(function (c) { return { char: c, color: 'red' }; });
    return r;
  }

  /* ─── DOM ───────────────────────────────────────────────── */
  var section = document.querySelector('.sign-creator-section');
  if (!section) return;

  var signWrapper  = section.querySelector('.sign-board-wrapper');
  var hiddenInput  = section.querySelector('.sign-hidden-input');
  var signRowEls   = section.querySelectorAll('.sign-row');
  var colorBtns    = section.querySelectorAll('.color-btn');
  var iconPicker   = section.querySelector('.icon-picker');
  var shareBtn     = section.querySelector('#sign-share-btn');
  var shareHint    = section.querySelector('#sign-share-hint');

  /* ─── Responsive font size ──────────────────────────────── */
  // Font size ≈ 11% of the sign board container width feels right
  // for the overlaid characters to fill each row height naturally.
  if (window.ResizeObserver && signWrapper) {
    var ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var w = entries[i].contentRect.width;
        entries[i].target.style.setProperty('--sign-font-size', Math.round(w * 0.085) + 'px');
      }
    });
    ro.observe(signWrapper);
  }

  /* ─── Render sign ───────────────────────────────────────── */
  function renderSign() {
    signRowEls.forEach(function (rowEl, i) {
      var charsEl = rowEl.querySelector('.sign-row__chars');
      rowEl.classList.toggle('is-selected', i === selectedRow);

      if (rows[i].length === 0) {
        charsEl.innerHTML = '';
        return;
      }

      var html = '';
      rows[i].forEach(function (item) {
        if (item.char === ' ') {
          html += '<span class="sign-char sign-char--space sign-char--' + item.color + '">&nbsp;</span>';
        } else {
          html += '<span class="sign-char sign-char--' + item.color + '"><span class="sign-char__text">' + escapeHTML(item.char) + '</span></span>';
        }
      });
      charsEl.innerHTML = html;
    });

  }

  /* ─── Row selection ─────────────────────────────────────── */
  function selectRow(i) {
    if (i < LOCKED_ROWS) return;
    selectedRow = i;
    renderSign();
    if (hiddenInput) hiddenInput.focus();
  }

  signRowEls.forEach(function (rowEl, i) {
    rowEl.addEventListener('click', function () { selectRow(i); });
  });

  /* ─── Color selection ───────────────────────────────────── */
  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      currentColor = btn.dataset.color;
      colorBtns.forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      var slider = btn.closest('.color-toggle-slider');
      if (slider) slider.dataset.active = btn.dataset.color;
    });
  });

  /* ─── Character input ───────────────────────────────────── */
  function addChar(char) {
    if (rows[selectedRow].length >= MAX_CHARS) return; // safety net
    rows[selectedRow].push({ char: char, color: currentColor });
    renderSign();

    // Check if this row now visually overflows — if so, move char to next row
    var rowEl = signRowEls[selectedRow];
    var charsEl = rowEl && rowEl.querySelector('.sign-row__chars');
    if (charsEl && charsEl.scrollWidth > charsEl.clientWidth) {
      rows[selectedRow].pop();
      if (selectedRow < NUM_ROWS - 1) {
        selectedRow++;
        rows[selectedRow].push({ char: char, color: currentColor });
        renderSign();
      }
      // else: all rows full — char is silently dropped
    }
  }

  function deleteChar() {
    if (rows[selectedRow].length > 0) {
      rows[selectedRow].pop();
    } else if (selectedRow > LOCKED_ROWS) {
      // Row is empty — step back and delete the last char on the previous row
      selectedRow--;
      if (rows[selectedRow].length > 0) rows[selectedRow].pop();
    }
    renderSign();
  }

  /* Icon picker */
  if (iconPicker) {
    iconPicker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-key]');
      if (btn) addChar(btn.dataset.key);
    });
  }

  /* Hidden input — captures both native mobile keyboard and desktop typing */
  if (hiddenInput) {
    hiddenInput.addEventListener('input', function (e) {
      /* Mobile backspace fires as deleteContentBackward */
      if (e.inputType === 'deleteContentBackward') {
        deleteChar();
        return;
      }
      var data = e.data;
      if (!data) return;
      data.split('').forEach(function (ch) {
        var char = ch.toUpperCase();
        if (char === ' ' || /[A-Z0-9&\-.,:!?'()\/#@+]/.test(char)) {
          addChar(char);
        }
      });
      hiddenInput.value = '';
    });

    hiddenInput.addEventListener('keydown', function (e) {
      if (e.key === 'Backspace') {
        e.preventDefault();
        deleteChar();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (selectedRow < NUM_ROWS - 1) {
          selectedRow++;
          renderSign();
        }
      } else if (e.key === 'ArrowDown' || e.key === 'Tab') {
        e.preventDefault();
        selectedRow = Math.min(NUM_ROWS - 1, selectedRow + 1);
        renderSign();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectedRow = Math.max(0, selectedRow - 1);
        renderSign();
      }
    });
  }

  /* ─── Share ─────────────────────────────────────────────── */
  var SHARE_CAPTION = 'Made with the Chez Greenberg sign maker! 📍 @chez.greenberg\nchezgreenberg.com/pages/sign';

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      shareBtn.disabled = true;
      if (shareHint) shareHint.textContent = 'Generating image…';

      var canvas_opts = {
        useCORS: true,
        scale: 2,
        backgroundColor: null,
        ignoreElements: function (el) { return el === hiddenInput; }
      };

      var captureStyle = document.createElement('style');
      captureStyle.textContent = '.sign-char__text { display: inline-block; transform: scaleX(0.75) translateX(-10%); transform-origin: center center; }';
      document.head.appendChild(captureStyle);

      html2canvas(signWrapper, canvas_opts).then(function (canvas) {
        document.head.removeChild(captureStyle);
        canvas.toBlob(function (blob) {
          var file = new File([blob], 'chez-greenberg-sign.png', { type: 'image/png' });

          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: 'My Chez Greenberg Sign',
              text: SHARE_CAPTION
            }).then(function () {
              if (shareHint) shareHint.textContent = '';
            }).catch(function (err) {
              if (err.name !== 'AbortError') fallbackDownload(canvas);
              if (shareHint) shareHint.textContent = '';
            }).finally(function () {
              shareBtn.disabled = false;
            });
          } else {
            // Desktop or unsupported browser — download the PNG
            fallbackDownload(canvas);
            if (shareHint) {
              shareHint.textContent = 'Image saved! Open Instagram and share it with caption: ' + SHARE_CAPTION;
            }
            shareBtn.disabled = false;
          }
        }, 'image/png');
      }).catch(function () {
        if (document.head.contains(captureStyle)) document.head.removeChild(captureStyle);
        shareBtn.disabled = false;
        if (shareHint) shareHint.textContent = 'Could not generate image. Please try again.';
      });
    });
  }

  function fallbackDownload(canvas) {
    var a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = 'chez-greenberg-sign.png';
    a.click();
  }

  /* ─── Helpers ───────────────────────────────────────────── */
  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─── Init ──────────────────────────────────────────────── */
  renderSign();

})();
